import { BibResponse } from './aud-bib-response.model';
import { GeoDsMeta } from './meta-data.model';
export class BibQuestion extends GeoDsMeta{
  ParentId: string;
  Designation: string;
  SeqNr: number;
  Title: string;
  Description: string;
  Type: string;
  SortNr?: number;
  Percentage?: number;
  MaxScore?: number;
  Factor?: number;
  Score?: number;
  Responses: BibResponse[];
  constructor(data?) {
    super();
    if (data) {
      Object.assign(this, data);
      if (data?.Responses) {
        this.Responses = [];
        data.Responses.forEach((response) => {
          this.Responses.push(new BibResponse(response));
        });
      }
    }
  }
}